import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

import { CallPurposeSection } from "./CallPurposeSection";

const MODAL_STACK_SPACING = 10;

interface InitialStepContentProps {
  onCallMeNow: () => void;
  onScheduleLater: () => void;
  isPendingScreening: boolean;
  isNotifyingRecruiter: boolean;
  screeningCalendlyLink?: string;
  showCallMeNow: boolean;
  source: "banner" | "detail-cta";
}

function getTitle(source: "banner" | "detail-cta"): string {
  if (source === "banner") {
    return "Schedule a quick phone call";
  }

  return "First step: Quick phone call";
}

export function InitialStepContent(props: InitialStepContentProps) {
  const {
    onCallMeNow,
    onScheduleLater,
    isPendingScreening,
    isNotifyingRecruiter,
    screeningCalendlyLink,
    showCallMeNow,
    source,
  } = props;

  const title = getTitle(source);

  return (
    <Stack spacing={MODAL_STACK_SPACING} alignItems="center" justifyContent="center">
      <Illustration type="phone" />

      <Stack spacing={10} alignItems="flex-start">
        <Text variant="h3" textAlign="center">
          {title}
        </Text>
        <CallPurposeSection />
      </Stack>

      <Stack spacing={4} alignSelf="stretch">
        {showCallMeNow && (
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isNotifyingRecruiter}
            onClick={onCallMeNow}
          >
            Call me now
          </LoadingButton>
        )}

        {!isPendingScreening && (
          <Button
            fullWidth
            variant="outlined"
            size="large"
            disabled={!screeningCalendlyLink}
            onClick={onScheduleLater}
          >
            Schedule the call for later
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
